/**
 * assets/kits-blog.js
 * Blog article: copy share link (clipboard) with data-ks-blog-copy-url */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ks-blog-copy-url]');
    if (!btn) return;
    var url = btn.getAttribute('data-ks-blog-copy-url');
    if (!url || !navigator.clipboard || !navigator.clipboard.writeText) return;
    e.preventDefault();
    navigator.clipboard.writeText(url).then(function () {
      btn.classList.add('is-copied');
      var prev = btn.getAttribute('aria-label');
      btn.setAttribute('data-ks-blog-copy-prev-label', prev || '');
      btn.setAttribute('aria-label', 'Link copied');
      window.setTimeout(function () {
        btn.classList.remove('is-copied');
        var p = btn.getAttribute('data-ks-blog-copy-prev-label');
        if (p) btn.setAttribute('aria-label', p);
      }, 2000);
    });
  });
})();
